import CenterMessage from "./CenterMessage";

export default function ErrorMessage() {
  return <CenterMessage message="Oops! Something went wrong." />;
}
